import React from 'react';

import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AttachmentsPageLoader } from '@confluence/attachments-page/entry-points/AttachmentsPage.tsx';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';

export const AttachmentsPageRoute: {
	({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(routeMatch: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				contentId: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element => {
	if (!expValEquals('cc_attachments_page', 'isEnabled', true)) {
		return <NotFound />;
	}
	return <AttachmentsPageLoader contentId={contentId} spaceKey={spaceKey} />;
};

AttachmentsPageRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params,
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			contentId: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => {
	const { spaceKey, contentId } = params;

	return {
		Screen: {
			screenEvent: { name: 'attachmentsPage', id: contentId },
			pageState: {
				routeName,
				contentId,
				spaceKey,
			},
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
		},
	};
};
